/* eslint-disable arrow-parens,no-param-reassign */

import api from './api.service';
import apiRoutes from './api.routes';

const getSocialAuthHREF = type => {
  type = type.toLowerCase();
  if (type === 'linkedin') type = 'linkedinv2';
  return `https://testal.yarea.io/social-login?provider=${type}`;
  // return `${api.baseRootUrl}/social-login?provider=${type}`;
};

const setSocial = async params => api.catchError(async () => {
  const { data } = await api.post(apiRoutes.socialLogin, params);
  return data;
});

const auth = async params => api.catchError(async () => {
  const { data } = await api.get(apiRoutes.socialLogin, params);
  return data;
});

export default {
  getSocialAuthHREF,
  setSocial,
  auth,
};



// WEBPACK FOOTER //
// ./src/services/social.service.js